import { UntypedFormGroup } from '@angular/forms';
import { AccountGroupLocation } from '@vendasta/account-group';
import { GlobalParticipantType } from '@vendasta/conversation';
import {
  AttachmentInterface as TaskAttachmentInterface,
  ConversationInterface,
  Status,
  TaskIdentityInterface,
} from '@vendasta/task';
import { PersonaType as IamPersonaType } from '@vendasta/iam';
import { CommentInterface, PersonaType, UserInfoInterface } from '@vendasta/task-manager';
import { Observable } from 'rxjs';

export interface Subtask {
  title?: string;
  dueDate?: Date;
  completionDate?: Date;
  status?: string;
  notes?: string;
  feedbackEnabled?: boolean;
  partnerId?: string;
  accountGroupId?: string;
  subtaskId?: string;
  files?: AttachmentInterface[];
  /** @deprecated use conversations field instead */
  feedback?: string[];
  approved?: boolean;
  showFeedback?: boolean;
  form?: UntypedFormGroup;
  conversations?: ConversationInterface[];
  tags?: string[];
}

export interface AttachmentInterface extends TaskAttachmentInterface {
  name?: string;
  url?: string;
  contentType?: string;
}

export interface AttachedFile extends File {
  url: string;
  contentType: string;
}

export interface ProjectTrackerInfo {
  projectTitle: string;
  projectIdentity: TaskIdentityInterface;
  projectConversations: ConversationInterface[];
  projectStatus?: string | Status;
  projectUrl?: string;
  subtasks: Subtask[];
}

export type NonClickableSection =
  | 'taskNumber'
  | 'taskTitle'
  | 'taskDueDate'
  | 'taskNotes'
  | 'taskFeedback'
  | 'taskAttachments';

export interface AskQuestionInfo {
  projectIdentity: TaskIdentityInterface;
  subtasks: Subtask[];
}

export interface ExtendedConversationInterface extends ConversationInterface {
  taskTitle?: string;
  senderImageUrl?: ExtendedCommentInterface['senderImageUrl'];
}

export interface ExtendedCommentInterface extends CommentInterface {
  taskTitle?: string;
}

export interface ProjectTrackerUserDetails {
  userId: string;
  personaType?: PersonaType | IamPersonaType;
  userInfo?: UserInfoInterface;
  profilePictureUrl?: string;
}

export interface AddCommentEvent {
  message: string;
  isPublic: boolean;
}

export interface ProductInfo {
  icon?: string;
  banner?: string;
  name?: string;
}

export interface OrganizationInfoInterface {
  id: string;
  name: Observable<string>;
  type: string;
  address?: AccountGroupLocation;
}

export interface ProjectOrganizationsInterface {
  projectId: string;
  organizationList: OrganizationInfoInterface[];
}

export enum OrganizationType {
  ACCOUNT_GROUP = 'account-group',
  PARTNER = 'partner',
  VENDOR = 'vendor',
}

export function adapterOrganizationType(organizationType: OrganizationType): GlobalParticipantType {
  switch (organizationType) {
    case OrganizationType.ACCOUNT_GROUP: {
      return GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP;
    }
    case OrganizationType.PARTNER: {
      return GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_PARTNER;
    }
    case OrganizationType.VENDOR: {
      return GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_VENDOR;
    }
    default: {
      return GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_UNDEFINED;
    }
  }
}
